var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSquareArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.122 12.6319L9.32145 21.4336C8.97219 21.7829 8.40585 21.783 8.05658 21.4337L5.87914 19.2562C5.52988 18.907 5.52988 18.3407 5.8791 17.9915L11.8698 11.9995L8.35803 8.4877L5.87924 6.0089C5.52997 5.65964 5.52997 5.09334 5.87924 4.74403L8.05663 2.56664C8.40589 2.21737 8.97219 2.21737 9.32145 2.56664L15.2425 8.4877L18.1219 11.3671C18.4712 11.7164 18.4712 12.2827 18.122 12.6319Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3106 8.5584L11.8684 12.0007L10.5526 10.685L8.35793 8.48753L5.87914 6.00873C5.52987 5.65946 5.52987 5.09317 5.87914 4.74385L8.05634 2.56665C8.4057 2.21729 8.97209 2.21738 9.32136 2.56684L13.9948 7.24281L15.3106 8.5584Z",
    fill: "#256056",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3102 8.55881L11.868 12.001L11.0332 11.1649L14.4754 7.72266L15.3102 8.55881Z",
    fill: "#256056",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareArrow);
export default __webpack_public_path__ + "static/media/square-arrow.1e7a05c1.svg";
export { ForwardRef as ReactComponent };